import React,{useEffect,useState} from 'react';
import {fetchAvailableModels,recommendModel} from '../utils/anthropicModels.js';

export default function AnthropicModelPicker({apiKey,proxyUrl,value,onChange}) {
  const [models,setModels]=useState([]);
  const [status,setStatus]=useState('idle');
  const [error,setError]=useState('');

  useEffect(()=> {
    if (!apiKey?.trim().startsWith('sk-ant-') || apiKey.trim().length < 40) {
      setModels([]);
      setStatus('idle');
      return;
    }

    const controller=new AbortController();
    const timer=setTimeout(async ()=> {
      setStatus('loading');
      setError('');
      try {
        const available=await fetchAvailableModels(apiKey,controller.signal,proxyUrl);
        if (controller.signal.aborted) return;
        setModels(available);
        setStatus('ready');
        if (!available.some((model)=> model.id===value)) {
          onChange(recommendModel(available));
        }
      } catch (err) {
        if (controller.signal.aborted) return;
        setModels([]);
        setStatus('error');
        setError(err.message);
      }
    },500);

    return ()=> {
      clearTimeout(timer);
      controller.abort();
    };
  },[apiKey,proxyUrl,onChange]);

  const recommended=recommendModel(models);

  return (
    <div>
      <label className="block text-xs font-semibold text-slate-400 mb-1.5 uppercase tracking-wider">
        Model<span className="text-indigo-400 ml-1">*</span>
      </label>
      <select
        required
        value={value}
        onChange={(event)=> onChange(event.target.value)}
        disabled={status !=='ready'}
        className="w-full bg-slate-950 border border-slate-700 rounded-lg px-4 py-2.5 text-white text-sm outline-none focus:ring-2 focus:ring-indigo-500 disabled:opacity-60"
      >
        <option value="">
          {status==='loading'
            ? 'Loading available models…'
            : 'Enter an API key to load models'}
        </option>
        {models.map((model)=> (
          <option key={model.id} value={model.id}>
            {model.display_name || model.id}{model.id===recommended ? ' · Recommended' : ''}
          </option>
        ))}
      </select>
      {status==='ready' && (
        <p className="text-xs text-green-400 mt-1">
          {models.length} models returned for this API key. Recommended: {recommended}
        </p>
      )}
      {status==='error' && (
        <p className="text-xs text-yellow-400 mt-1">
          {error} You can still submit with the currently selected model; generation will try it anyway.
        </p>
      )}
    </div>
  );
}